import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import ModuleList from '../../../layout/ModuleList';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { DELIVERY_POSTAL_CODE_PRICE_COLUMNS } from '../../../../config/columns';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import {
  DELIVERY_POSTAL_CODE_PRICE_PATH,
  NEW_DELIVERY_POSTAL_CODE_PRICE_PATH,
} from '../../../../config/paths';
import {
  clearDeliveryPostalCodePrices,
  getDeliveryPostalCodePrices,
} from '../../../../actions/cargo/DeliveryPostalCodePrice';

const DeliveryPostalCodePrices = ({
  breadcrumbs,
  deliveryPostalCodePrices,
  loading,
  dispatchGetDeliveryPostalCodePrices,
  dispatchClearDeliveryPostalCodePrices,
}) => {
  useLayoutEffect(() => () => dispatchClearDeliveryPostalCodePrices(), []);

  const data = deliveryPostalCodePrices.get('content') || [];
  const pages = deliveryPostalCodePrices.get('totalPages') || null;
  const defaultPageSize =
    deliveryPostalCodePrices.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Tarifarios de Reparto por Código Postal"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_DELIVERY_POSTAL_CODE_PRICE_PATH}
      tableStructure={{
        columns: DELIVERY_POSTAL_CODE_PRICE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetDeliveryPostalCodePrices,
        modelPath: DELIVERY_POSTAL_CODE_PRICE_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetDeliveryPostalCodePrices: getDeliveryPostalCodePrices,
  dispatchClearDeliveryPostalCodePrices: clearDeliveryPostalCodePrices,
};

DeliveryPostalCodePrices.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  deliveryPostalCodePrices: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetDeliveryPostalCodePrices: PropTypes.func.isRequired,
  dispatchClearDeliveryPostalCodePrices: PropTypes.func.isRequired,
};

const mapStateToProps = ({ CargoUnit }) => ({
  breadcrumbs: [
    ...CargoUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tarifarios de Reparto por Código Postal',
      href: DELIVERY_POSTAL_CODE_PRICE_PATH,
    },
  ],
  deliveryPostalCodePrices: CargoUnit.DeliveryPostalCodePrice.getIn([
    'all',
    'content',
  ]),
  loading: CargoUnit.DeliveryPostalCodePrice.getIn(['all', 'loading']),
});

DeliveryPostalCodePrices.defaultProps = {
  deliveryPostalCodePrices: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeliveryPostalCodePrices);
